import React, { useState } from 'react';
import { Upload, Wand2, Download, Image as ImageIcon } from 'lucide-react';
import { Button } from '../components/ui/button';

const WatermarkRemover = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [processedImage, setProcessedImage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setSelectedImage(url);
      setProcessedImage(null);
    }
  };

  const handleProcess = () => {
    setIsProcessing(true);
    // Simulate processing
    setTimeout(() => {
      setProcessedImage(selectedImage);
      setIsProcessing(false);
    }, 2000);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center">
          <Wand2 size={20} className="text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-white">Watermark Remover</h1>
          <p className="text-gray-400">Remove watermarks from your images using AI</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Upload Section */}
        <div className="bg-[#1a1a2e] rounded-xl p-6 border border-gray-800">
          <h2 className="text-white font-semibold mb-4">Original Image</h2>
          {selectedImage ? (
            <div className="space-y-4">
              <div className="aspect-video bg-[#12121a] rounded-lg overflow-hidden">
                <img
                  src={selectedImage}
                  alt="Selected"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  className="flex-1 border-gray-700 text-gray-300 hover:bg-gray-800"
                  onClick={() => setSelectedImage(null)}
                >
                  Remove
                </Button>
                <Button
                  className="flex-1 bg-purple-600 hover:bg-purple-700"
                  onClick={handleProcess}
                  disabled={isProcessing}
                >
                  {isProcessing ? (
                    <span className="flex items-center gap-2">
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                      Processing...
                    </span>
                  ) : (
                    <span className="flex items-center gap-2">
                      <Wand2 size={18} />
                      Remove Watermark
                    </span>
                  )}
                </Button>
              </div>
            </div>
          ) : (
            <label className="block">
              <div className="aspect-video bg-[#12121a] rounded-lg border-2 border-dashed border-gray-700 flex flex-col items-center justify-center cursor-pointer hover:border-purple-500 transition-colors">
                <Upload size={48} className="text-gray-600 mb-4" />
                <p className="text-gray-400 mb-2">Click to upload an image</p>
                <p className="text-gray-500 text-sm">PNG, JPG up to 10MB</p>
              </div>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="hidden"
              />
            </label>
          )}
        </div>

        {/* Result Section */}
        <div className="bg-[#1a1a2e] rounded-xl p-6 border border-gray-800">
          <h2 className="text-white font-semibold mb-4">Processed Image</h2>
          {processedImage ? (
            <div className="space-y-4">
              <div className="aspect-video bg-[#12121a] rounded-lg overflow-hidden">
                <img
                  src={processedImage}
                  alt="Processed"
                  className="w-full h-full object-contain"
                />
              </div>
              <Button className="w-full bg-green-600 hover:bg-green-700">
                <Download size={18} className="mr-2" />
                Download Image
              </Button>
            </div>
          ) : (
            <div className="aspect-video bg-[#12121a] rounded-lg flex flex-col items-center justify-center">
              <ImageIcon size={48} className="text-gray-600 mb-4" />
              <p className="text-gray-400">Processed image will appear here</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WatermarkRemover;
